import { render, staticRenderFns } from "./TestPivot.vue?vue&type=template&id=6c44b75c"
import script from "./TestPivot.vue?vue&type=script&lang=js"
export * from "./TestPivot.vue?vue&type=script&lang=js"
import style0 from "./TestPivot.vue?vue&type=style&index=0&id=6c44b75c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports